import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("chatbots.config.title"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(_vm._s(_vm.$t("chatbots.config.config_description"))),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goCreatePage()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-filter-order1", class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.data,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.chatbot",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              _vm._s(
                                (
                                  _vm.chatbots.find(function (c) {
                                    return c.id === item.chatbot
                                  }) || {}
                                ).name || "Desconocido"
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.playground",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _vm._v(
                              _vm._s(
                                (
                                  _vm.playgrounds.find(function (c) {
                                    return c.id === item.playground
                                  }) || {}
                                ).name || "Desconocido"
                              )
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditProject(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-edit"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onViewProject(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-view"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer pb-0",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t("chatbots.domain"),
                                      placeholder: _vm.$t("chatbots.domain"),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.domain,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "domain", $$v)
                                      },
                                      expression: "filters.domain",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "dialogs-component",
        { ref: "DIALOG_CONFIG", attrs: { title: "Config", width: 850 } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(VTab, [_vm._v("Configuración general")]),
                  _c(VTab, [_vm._v("Usuarios")]),
                  _c(VTab, [_vm._v("Grupo de usuarios")]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  staticClass: "pt-2",
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    [
                      _c(
                        VForm,
                        { ref: "form_project", attrs: { id: "form_project" } },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(_vm.$t("chatbots.domain")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _vm.view || _vm.edit
                                    ? _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          filled: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.item_selected.domain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item_selected,
                                              "domain",
                                              $$v
                                            )
                                          },
                                          expression: "item_selected.domain",
                                        },
                                      })
                                    : _c("organizacion-component", {
                                        attrs: {
                                          custom_orgs: _vm.list_orgs,
                                          show_all: false,
                                        },
                                        model: {
                                          value: _vm.item_selected.domain,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.item_selected,
                                              "domain",
                                              $$v
                                            )
                                          },
                                          expression: "item_selected.domain",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.config.metadata.limit"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.number,
                                      type: "number",
                                    },
                                    model: {
                                      value: _vm.item_selected.limit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "limit",
                                          $$v
                                        )
                                      },
                                      expression: "item_selected.limit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.config.metadata.quota"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.number,
                                      type: "number",
                                    },
                                    model: {
                                      value: _vm.item_selected.quota,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "quota",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "item_selected.quota",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Orgs:")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      multiple: "",
                                      "item-value": "domain",
                                      "item-text": "alias",
                                      items: _vm.list_orgs,
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.otros,
                                    },
                                    model: {
                                      value: _vm.item_selected.orgs,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.item_selected, "orgs", $$v)
                                      },
                                      expression: "item_selected.orgs",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.data_center.metadata.vector_database"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.type_bd_vectorial,
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.dependent(
                                        _vm.item_selected.source_embedding
                                      ),
                                    },
                                    model: {
                                      value: _vm.item_selected.database_service,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "database_service",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "item_selected.database_service",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.data_center.metadata.database_instance"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.filteredInstances,
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.dependent(
                                        _vm.item_selected.database_service
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.item_selected.database_instance,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "database_instance",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "item_selected.database_instance",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.data_center.metadata.embedding_source"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.type_embedding_source,
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.dependent(
                                        _vm.item_selected.database_service
                                      ),
                                    },
                                    model: {
                                      value: _vm.item_selected.source_embedding,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "source_embedding",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "item_selected.source_embedding",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "chatbots.data_center.metadata.embedding"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.filteredEmbeddings,
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.dependent(
                                        _vm.item_selected.source_embedding
                                      ),
                                    },
                                    model: {
                                      value: _vm.item_selected.tipo_embedding,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "tipo_embedding",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "item_selected.tipo_embedding",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Chatbot")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.otros,
                                      items: _vm.chatbots,
                                      "item-value": "id",
                                      "item-text": "name",
                                    },
                                    model: {
                                      value: _vm.item_selected.chatbot,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "chatbot",
                                          $$v
                                        )
                                      },
                                      expression: "item_selected.chatbot",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Playground")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.otros,
                                      items: _vm.playgrounds,
                                      "item-value": "id",
                                      "item-text": "name",
                                    },
                                    model: {
                                      value: _vm.item_selected.playground,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.item_selected,
                                          "playground",
                                          $$v
                                        )
                                      },
                                      expression: "item_selected.playground",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c(
                        VCard,
                        [
                          _c(
                            VCardTitle,
                            [
                              _vm._v("Usuarios"),
                              _c(VSpacer),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-1 btn-inca-secondary",
                                  attrs: { outlined: "", dense: "" },
                                  on: { click: _vm.onAddUser },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-add"),
                                  ]),
                                  _vm._v("Agregar usuario"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VCardText),
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headersUsuarios,
                              items: _vm.usuarios,
                              "hide-default-footer": "",
                              "item-key": "id",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.user",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.edit
                                      ? _c(VTextField, {
                                          attrs: {
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                            placeholder: "Correo de usuario",
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                              function (v) {
                                                return (
                                                  /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                                    v
                                                  ) ||
                                                  _vm.$t(
                                                    "my_tasks.modals.email_invalid"
                                                  )
                                                )
                                              },
                                            ],
                                          },
                                          model: {
                                            value: item.user,
                                            callback: function ($$v) {
                                              _vm.$set(item, "user", $$v)
                                            },
                                            expression: "item.user",
                                          },
                                        })
                                      : _c("span", [_vm._v(_vm._s(item.user))]),
                                  ]
                                },
                              },
                              {
                                key: "item.quota",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.edit
                                      ? _c(VTextField, {
                                          staticStyle: { "max-width": "100px" },
                                          attrs: {
                                            type: "number",
                                            dense: "",
                                            outlined: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: item.quota,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "quota",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "item.quota",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(_vm._s(item.quota)),
                                        ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.edit
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onSaveUser(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-content-save")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onCancelEdit(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-cancel")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditUser(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-edit")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onRemoveUser(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-delete")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c(
                        VCard,
                        [
                          _c(
                            VCardTitle,
                            [
                              _vm._v("Grupos de usuarios"),
                              _c(VSpacer),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-1 btn-inca-secondary",
                                  attrs: { outlined: "", dense: "" },
                                  on: { click: _vm.onAddGroup },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-add"),
                                  ]),
                                  _vm._v("Agregar grupo"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCardText,
                            [
                              _c(VDataTable, {
                                staticClass: "table-inca",
                                attrs: {
                                  headers: _vm.headersGroupUsuarios,
                                  items: _vm.item_selected.groups,
                                  "hide-default-footer": "",
                                  "item-key": "id",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.name",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        item.edit
                                          ? _c(
                                              "div",
                                              [
                                                _c(VTextField, {
                                                  attrs: {
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                    placeholder:
                                                      "Nombre del grupo",
                                                  },
                                                  model: {
                                                    value: item.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.name",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.users",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        item.edit
                                          ? _c(
                                              "div",
                                              [
                                                _c(VTextField, {
                                                  attrs: {
                                                    "hide-no-data": "",
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "my_tasks.modals.required"
                                                          )
                                                        )
                                                      },
                                                      function (v) {
                                                        return (
                                                          /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                                            v
                                                          ) ||
                                                          _vm.$t(
                                                            "my_tasks.modals.email_invalid"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                    placeholder:
                                                      "Agregar correo y presionar enter",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onAddCorreo(
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.nuevoCorreo,
                                                    callback: function ($$v) {
                                                      _vm.nuevoCorreo = $$v
                                                    },
                                                    expression: "nuevoCorreo",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-2" },
                                                  _vm._l(
                                                    item.users,
                                                    function (correo, index) {
                                                      return _c(
                                                        VChip,
                                                        {
                                                          key: index,
                                                          staticClass: "ma-1",
                                                          attrs: {
                                                            small: "",
                                                            close: "",
                                                          },
                                                          on: {
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.onRemoveCorreo(
                                                                  item,
                                                                  index
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(correo))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  VChipGroup,
                                                  { attrs: { column: "" } },
                                                  _vm._l(
                                                    item.users,
                                                    function (correo, index) {
                                                      return _c(
                                                        VChip,
                                                        {
                                                          key: index,
                                                          staticClass: "ma-1",
                                                          attrs: {
                                                            small: "",
                                                            outlined: "",
                                                            color: "primary",
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(correo))]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.quota",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        item.edit
                                          ? _c(
                                              "div",
                                              [
                                                _c(VTextField, {
                                                  staticStyle: {
                                                    "max-width": "100px",
                                                  },
                                                  attrs: {
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                    type: "number",
                                                  },
                                                  model: {
                                                    value: item.quota,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "quota",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "item.quota",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(item.quota)),
                                            ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.actions",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        !item.edit
                                          ? _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditGroup(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-edit")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.edit
                                          ? _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onSaveGroup(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-content-save")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        item.edit
                                          ? _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onCancelEditGroup(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-cancel")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onRemoveGroup(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.edit || _vm.view == false
                ? _c(
                    VBtn,
                    {
                      staticClass: "primary mr-1",
                      on: {
                        click: function ($event) {
                          _vm.edit ? _vm.onUpdateConfig() : _vm.onSaveConfig()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.save")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }